/* eslint-disable css-modules/no-unused-class, camelcase, no-empty-function  */
import { InnerTable, Avatar, Icon, TableData } from 'learning-panel-components';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetUsersLeaderboards } from '@queries/core/homepage';
import { coreService } from 'network-utils';
import { selectIsPLG, selectToken } from '@redux/slices/userSlice';
import styles from './leaderboard.module.scss';

const InnerTableContainer: FC<{
    isOpen: boolean;
    teamUuid: string;
    searchString: string;
}> = ({ isOpen, teamUuid, searchString }: { isOpen: boolean; teamUuid: string; searchString: string }) => {
    const token = useSelector(selectToken);
    const isPLG = useSelector(selectIsPLG);
    const [offset, setOffset] = useState<number>(0);
    const leaderBoardLinesNumber = 10;

    const { data: usersLeaderboardsData } = useGetUsersLeaderboards(token, {
        search: searchString,
        offset,
        limit: leaderBoardLinesNumber,
        teamUuid,
        enableQuery: !isPLG
    });
    const getRows = (members: coreService.HomeUserLeaderboard[]) => {
        return members.map((member: coreService.HomeUserLeaderboard) => {
            return getRow(member);
        });
    };

    const onLoadMore = () => {
        setOffset(offset + leaderBoardLinesNumber);
    };

    const getRow = (row: coreService.HomeUserLeaderboard) => {
        const iconElement = <div className={styles['rank-wrapper']}>#{row.rank}</div>;
        const nameElement = (
            <div className={styles['row-name']}>
                <Avatar name={row.name} avatarSrc={row.profilePicture} size="1.7rem" />
                <div className={styles.text}>
                    <div>{row.name}</div>
                </div>
            </div>
        );
        const scoreElement = (
            <div className={styles['row-score']}>
                <Icon name="devCoin" className={styles['dev-coin']} />
                <div>{row.totalScore?.toLocaleString() || 0}</div>
            </div>
        );
        return [iconElement, nameElement, scoreElement];
    };

    return (
        <>
            {usersLeaderboardsData && (
                <InnerTable
                    isOpen={isOpen}
                    innerRows={getRows(usersLeaderboardsData.results)}
                    hasMoreRows={false}
                    loadMoreRows={onLoadMore}
                />
            )}
        </>
    );
};

export default InnerTableContainer;
